import script from "./ClassroomWrongDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomWrongDevice.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomWrongDevice.vue?vue&type=style&index=0&id=23bf67c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bf67c0"]])

export default __exports__